import React from 'react';
import styled, { css } from 'styled-components';

import { surveyAnalytics } from '@r1-frontend/survey/analytics';
import { useCtxSelector } from '@r1-frontend/survey/context/hooks';
import useSurvey from '@r1-frontend/survey/context/hooks/useSurvey';
import { getCommonSurvey, getCommonSurveyButton } from '@r1-frontend/survey/context/selectors';

import { ButtonQuiz } from '@r1-frontend/ui-kit/molecules/ButtonQuiz';
import { ThemedProperties } from '@r1-frontend/ui-kit/themes/types';

const SurveyButton = styled((props) => {
    const commonSurvey = useCtxSelector(getCommonSurvey);
    const surveyButton = useCtxSelector(getCommonSurveyButton) || {};

    const survey = useSurvey();

    if (!commonSurvey || survey.isComplete(commonSurvey.name)) {
        return null;
    }

    const handleClick = () => {
        surveyAnalytics.common.clickSurveyButton();
        survey.show({ type: 'common', inPopup: true });
    };

    return (
        <div {...props}>
            <ButtonQuiz onClick={handleClick} {...surveyButton}/>
        </div>
    );
})`
    ${({ theme }: ThemedProperties) => css`
        position: fixed;
        z-index: 202;
        bottom: ${theme.indents.l}px;
        left: ${theme.indents.xl}px;
    `};
`;

SurveyButton.displayName = 'SurveyButton';

export { SurveyButton };
